import { Button as BaseButton } from "antd";
import styled from "styled-components";

const DrawerButton = styled(BaseButton)`
  align-items: center;
  font-size: 14px;
  padding: 0 0.75em;
`;

export default DrawerButton;
